const Action = require("../../entities/Action");
const {Age}  = require("../Constants");
const ActionNames = require("../Names/ActionNames");

class RichLand extends Action {
    constructor(age){
        super(
            age,
            ActionNames.RichLand, 
            `Build or upgrade a mine or farm; pay ${RichLand.GetResourceAmount(age)} resource less.`,
            {
                playerStateAltering:
                (playerState) => {
                    //Do stuff
                }
            },
            {}
        )
    }

    static GetResourceAmount(age){
        switch (age)
        {
            default:
                return null;
            case Age.AgeA:
                return 1;
            case Age.Age1:
                return 2;
            case Age.Age2:
                return 3;
        }
    }
}

module.exports = RichLand;
